import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet'
import { Rail } from './Rail'
import { Sidebar } from './Sidebar'

// 서랍 — 좁은 화면에서 상단 바의 손잡이가 여는 왼쪽 패널.
// 레일과 사이드바를 그대로 담는다: 메뉴의 원본은 nav.ts 하나이고 서랍이 그것을 다시 만들지 않는다.
// 폭 19rem 은 레일 4rem 과 사이드바 15rem 의 합이라 넓은 화면과 같은 배치가 그대로 들어간다.

export function NavDrawer({
  open,
  onOpenChange,
  pending,
}: {
  open: boolean
  onOpenChange: (v: boolean) => void
  pending: number
}) {
  const { pathname } = useLocation()

  // 메뉴를 고르면 닫는다 — 닫지 않으면 고른 화면을 서랍이 덮은 채로 남는다.
  useEffect(() => {
    onOpenChange(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[19rem] flex-row gap-0 p-0">
        <SheetTitle className="sr-only">메뉴</SheetTitle>
        <Rail pending={pending} />
        <Sidebar />
      </SheetContent>
    </Sheet>
  )
}
